module.exports = __webpack_public_path__ + "static/img/dailyActivity.1e70fbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/fzkHome/dailyActivity.png
// module id = bsn5
// module chunks = 55